import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { twJoin } from 'tailwind-merge';

import Box from 'shopper/components/Box';

import Image from 'components/Image';

import { sendEvent } from 'lib/gtag';

import APP from 'constants/app';
import LINKS from 'constants/links';

const GA_EVENT_CATEGORY = 'download_app_sidebar';

const AppBanner = forwardRef(({ className }, ref) => (
  <Box
    ref={ref}
    as="a"
    className={twJoin('hidden md:flex', className)}
    href={LINKS.APP_DOWNLOAD}
    rel="noopener noreferrer"
    target="_blank"
    onClick={() => {
      sendEvent({
        action: 'download_app',
        category: GA_EVENT_CATEGORY,
      });
    }}
  >
    <Image
      alt="Baixando o aplicativo do Promobit você economiza até 3 vezes mais"
      className="w-full rounded-2"
      height={168}
      src={`${APP.LOCAL_IMAGE_PATH}/features/sidebar/app-banner-2.png`}
      width={304}
    />
  </Box>
));

AppBanner.displayName = 'AppBanner';

AppBanner.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default AppBanner;
